export const SET_SNACKBAR = "SET_SNACKBAR";
export const GET_USER = "GET_USER";
